import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import ArtisansList from './ArtisansList';
import ArtisansForm from './ArtisansForm';
import Content from '../../../_psb/layout/Content';
import SubHeader from '../../../_psb/layout/sub-header/SubHeader';
import Search from '../../../components/form/Search';
import { connect } from 'react-redux';
import { setSearchValueAction } from '../../../modules/artisans/Actions';
import { searchValueSelector } from '../../../modules/artisans/Selectors';
import getLangData from '../../../utils/getLangData';

const artisans = props => {
  const { searchValue, setSearchValue } = props;
  return (
    <>
      <SubHeader
        title={getLangData().general_words.artisans}
        Component={() => (
          <>
            <Switch>
              <Route
                exact
                path='/artisans'
                component={() => {
                  return (
                    <>
                      <span className='kt-subheader__separator kt-subheader__separator--v'></span>
                      <Search
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                      />
                    </>
                  );
                }}
              />
            </Switch>
          </>
        )}
      >
        <Switch>
          <Route
            exact
            path='/artisans'
            component={() => (
              <Link to='/artisans/create' className='btn btn-primary'>
                {getLangData().buttons.add_new}
              </Link>
            )}
          />

          {/* <Route
            exact
            path={["/artisans/create", "/artisans/:id"]}
            component={() => {
              return (
                <Link
                  to='/artisans'
                  className='btn-label-brand btn btn-bold'
                >
                  Back To List{" "}
                </Link>
              );
            }}
          /> */}
        </Switch>
      </SubHeader>
      <Content>
        <Switch>
          <Route exact path='/artisans' component={ArtisansList} />
          <Route exact path='/artisans/create' component={ArtisansForm} />
          <Route exact path='/artisans/:id' component={ArtisansForm} />
        </Switch>
      </Content>
    </>
  );
};

const mapStateToProps = state => ({
  searchValue: searchValueSelector(state)
});

const mapDispatchToProps = {
  setSearchValue: setSearchValueAction
};

export default connect(mapStateToProps, mapDispatchToProps)(artisans);
